"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var _set2 = _interopRequireDefault(require("lodash/set"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iframeResizer = require("iframe-resizer");

var _classnames = _interopRequireDefault(require("classnames"));

var _queryString = _interopRequireDefault(require("query-string"));

var _wpEmbedModule = _interopRequireDefault(require("./wp-embed.module.less"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WpEmbed =
/*#__PURE__*/
function (_Component) {
  _inherits(WpEmbed, _Component);

  function WpEmbed() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WpEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WpEmbed)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      ready: false
    });

    _defineProperty(_assertThisInitialized(_this), "onIframeRef", function (ref) {
      if (!ref) return;
      _this.frameRef = ref; // setup iframe-resizer

      var config = {
        checkOrigin: false,
        log: process.env.CONFIG_ENV === 'development',
        resizedCallback: _this.onFrameResize
      };
      (0, _iframeResizer.iframeResizer)(config, ref);
    });

    _defineProperty(_assertThisInitialized(_this), "onFrameResize", function () {
      _this.setIframeVisible();
    });

    _defineProperty(_assertThisInitialized(_this), "onFrameLoad", function () {
      _this.setIframeVisible();
    });

    _defineProperty(_assertThisInitialized(_this), "onInfogramResize", function (e) {
      // Do some easy early returns
      if (!_this.frameRef) return false;
      if (_this.frameRef.contentWindow !== e.source) return false; // Try to parse data json

      var data;

      try {
        data = JSON.parse(e.data);
      } catch (error) {
        return false;
      }

      if (data.context !== 'iframe.resize') {
        return false;
      }

      if (!data.height) return false;
      _this.frameRef.height = data.height;
    });

    _defineProperty(_assertThisInitialized(_this), "setIframeVisible", function () {
      if (_this.state.ready) return;

      if (_this.setVisibleTimeout) {
        clearTimeout(_this.setVisibleTimeout);
        _this.setVisibleTimeout = undefined;
      }

      _this.setState({
        ready: true
      });
    });

    return _this;
  }

  _createClass(WpEmbed, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setVisibleTimeout = setTimeout(this.setIframeVisible, 3000);
      window.addEventListener('message', this.onInfogramResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onInfogramResize);
      if (this.setVisibleTimeout) clearTimeout(this.setVisibleTimeout);
      if (!this.frameRef) return;
      this.frameRef.iFrameResizer.close();
    }
  }, {
    key: "render",
    value: function render() {
      var nwaModeParam = 'nwaMode';
      var embedUrl = this.props.src;

      var parsedUrl = _queryString.default.parseUrl(embedUrl);

      var urlIncludesNwaModeParam = function urlIncludesNwaModeParam() {
        return (0, _get2.default)(parsedUrl, ['query', nwaModeParam]);
      };

      var finalEmbedUrl;

      if (embedUrl && !urlIncludesNwaModeParam()) {
        var finalQueryString = _queryString.default.stringify((0, _set2.default)(parsedUrl.query, nwaModeParam, 'embed'));

        finalEmbedUrl = "".concat(parsedUrl.url, "?").concat(finalQueryString);
      } else {
        finalEmbedUrl = embedUrl;
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_wpEmbedModule.default['embed-container'], this.props.className)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(_wpEmbedModule.default.embed, _defineProperty({}, _wpEmbedModule.default.ready, this.state.ready))
      }, _react.default.createElement("iframe", {
        // eslint-disable-line jsx-a11y/iframe-has-title
        scrolling: "no",
        ref: this.onIframeRef,
        src: finalEmbedUrl,
        onLoad: this.onFrameLoad,
        title: ""
      })));
    }
  }]);

  return WpEmbed;
}(_react.Component);

WpEmbed.defaultProps = {
  className: ''
};
WpEmbed.propTypes = {
  /**
   * Fully qualified URI to embed source
   * eg: https://embeds.nerdwallet.com/embeds/379315.html?nwaMode=embed
   */
  src: _propTypes.default.string.isRequired,
  className: _propTypes.default.string
};
var _default = WpEmbed;
exports.default = _default;
WpEmbed.__docgenInfo = {
  "description": "",
  "displayName": "WpEmbed",
  "props": {
    "src": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Fully qualified URI to embed source\neg: https://embeds.nerdwallet.com/embeds/379315.html?nwaMode=embed"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "''",
        "computed": false
      }
    }
  }
};